import React from 'react';

//boostrap
import { Button } from "reactstrap";

function BtnViewEmail({ handleToggleEmailTemplate, values }) {
    return (
        <Button
            className="btn-warning text-1 justify-content-center px-2 mx-1"
            color="warning"
            onClick={() => handleToggleEmailTemplate(values)}
        >
            <i className="fa fa-envelope mr-2" aria-hidden="true"></i>View Email
        </Button>
    );
};

export default BtnViewEmail;